export function padding(a, length, padString = '0') {
  const str = a.toString();
  if (str.length > length) {
    return str;
  }
  let prefix = '';
  for (let i = str.length; i < length; i++) {
    prefix += padString;
  }
  return prefix + str;
}

export function yuanDigit(value: number) {
  if (value === 0) {
    return '0.00';
  }
  const neg = value < 0;
  value = Math.abs(value);
  const m = value % 100;
  const d = value < 100 ? '0' : (value - m).toString().slice(0, -2);
  let f = m.toString();
  if (f.length === 0) {
    f = '00';
  } else if (f.length === 1) {
    f = '0' + f;
  }
  return `${neg ? '-' : ''}${d}.${f}`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/string.ts